import { makeAutoObservable } from 'mobx'
import * as API from '../../../service/api/InfoStat/LogManageApi'
import table from '../../commons/table'
import { downloadFileStream } from '../../../util'
import { LOG_TYPE } from 'models/InfoStat/LogManage.model'

class LogManageStore {
  constructor() {
    makeAutoObservable(this)
  }

  setStoreByKey = (key, val) => {
    this[key] = val
  }

  logApiMap = new Map([
    [
      LOG_TYPE.OPERATE_LOG,
      {
        tableApi: API.GET_OPERATE_LOG_LIST,
        exportApi: API.EXPORT_OPERATE_LOG_LIST,
        exportName: '操作日志'
      }
    ],
    [
      LOG_TYPE.SYSTEM_LOG,
      {
        tableApi: API.GET_SYS_LOG_LIST,
        exportApi: API.EXPORT_SYS_LOG_LIST,
        exportName: '系统日志'
      }
    ],
    [
      LOG_TYPE.ERROR_LOG,
      {
        tableApi: API.GET_ERROR_LOG_LIST,
        exportApi: API.EXPORT_ERROR_LOG_LIST,
        exportName: '错误日志'
      }
    ]
  ])

  activeLogType = LOG_TYPE.OPERATE_LOG

  get table() {
    return new table(this.logApiMap.get(this.activeLogType)?.tableApi)
  }

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  exportLog = async (data) => {
    let res = await this.logApiMap.get(this.activeLogType)?.exportApi(data)
    downloadFileStream(res, this.logApiMap.get(this.activeLogType)?.exportName)
  }
}

export default new LogManageStore()
